<div class="offers">
  <div class="offers__title">
    <h2>Elige tu plan de pago en hasta 12 cuotas</h2>
    <p>Paga hoy solo la primera cuota con <span>todas las tarjetas de crédito.</span></p>
    <div class="offers__title__blue-decoration">
      <img src="./assets/img/icon/purple-decoration.svg" alt="Decoración azul claro" />
    </div>
  </div>
  <div class="offers__body">
    <ng-container *ngIf="offers$ | async as offers">
      <div class="offers__body__container" [ngClass]="{ 'no-offer': offers.length === 0}">
        <p class="offers__body__container__text">
          <ng-container *ngIf="amount$ | async as amount">
            Estos son los planes de pago que
            <span class="powerpay"><b>{{ CONST.BBVA_PRODUCT_NAME }} </b></span> te ofrece para tu
            compra de <span class="amount"> <b>{{amount | powerpayCurrency}} </b> </span
            ><br /><br />
          </ng-container>
        </p>
        <div
          class="offers__body__container__installments max-width-box"
          *ngIf="!(isLoading$ | async) && offers.length > 0"
          [ngClass]="{empty: offers.length === 0}"
        >
          <ng-container *ngFor="let offer of offers">
            <home-offer-card
              [offer]="offer"
              [previewOffer]="setPreviewOfferById(offer?.id)"
              [amount]="amount$ | async"
              [selected]="offerSelected"
              [typeOffer]="offer?.repayment_frequency?.minimum_installments"
              [exampleOffers]="!!(amount$ | async)"
              [offerSelected]="offerSelected"
              (offerSelected$)="handleOffer($event)"
              (previewOfferSelected$)="handlePreviewOffer($event)"
            ></home-offer-card>
          </ng-container>
        </div>
        <ng-container *ngIf="offers.length === 0">
          <div class="offers__body__container__no-offer">
            <img src="/assets/icons/yellow-info.svg" alt="Ícono de advertencia amarillo" />
            <h1>El valor de tu compra no aplica para ninguna oferta.</h1>
          </div>
        </ng-container>
      </div>
      <div class="offers__body__container__info-tcea" *ngIf="offers.length > 0">
        <p>(TCEA variable entre 0% y 66% según monto y plan elegido.)</p>
        <div class="tooltip">
          <layout-tooltip
            [content]="TOOLTIP_CONTENT.OFFERS_PAGE"
            [position]="ETOOLTIP_POSITION.ABOVE"
            [delay]="TOOLTIP_DELAY.THREE_SECONDS"
          >
          </layout-tooltip>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="offers$ | async as offers">
      <div
        class="offers__body__container__installments max-width-box"
        *ngIf="(isLoading$ | async) && offers.length > 0"
      >
        <layout-skeleton [data]="skeletonConfig"></layout-skeleton>
        <layout-skeleton [data]="skeletonConfig"></layout-skeleton>
        <layout-skeleton [data]="skeletonConfig"></layout-skeleton>
      </div>
    </ng-container>

    <ng-container *ngIf="!(isLoading$ | async)">
      <ng-container *ngIf="offers$ | async as offers">
        <div class="offers__body__summary">
          <div class="offers__body__summary__container">
            <home-summary
              [amount]="amount$ | async"
              [offerSelected]="offerSelected"
              [previewOffer]="previewOfferSelected"
              (killPurchaseEvent)="onKillPurchase()"
              (selectOfferId$)="onSelectOfferId($event)"
              [isDisabledButton]="!(offerSelected)"
              *ngIf="offers.length > 0"
            ></home-summary>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="offers$ | async as offers">
      <ng-container *ngIf="offers.length != 0">
        <div class="offers__body__buttons">
          <div class="offers__body__buttons__container">
            <button
              class="btn-primary-bg pay"
              type="submit"
              (click)="onSelectOfferId(previewOfferSelected.id)"
              [disabled]="!(offerSelected)"
            >
              Continuar
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="offers$ | async as offers">
      <ng-container *ngIf="(isLoading$ | async) && offers.length > 0">
        <layout-skeleton [data]="summarySkeletonConfig"></layout-skeleton>
      </ng-container>
    </ng-container>
  </div>
</div>
